<script lang="ts">
    import { page } from '$app/stores';
    import { toggleClasses } from '$src/lib/actions/toggleClasses';
    import { initGatekeeper } from '$src/lib/services/gatekeeper';
    import type { Bootstrap } from '$src/lib/services/legacy/auth/types';
    import { writable } from 'svelte/store';

    export let authBootstrap: Bootstrap;
    export let onGatekeeperInitiated: () => void;

    const noScroll = writable(false);

    const updateGatekeeperContext = initGatekeeper({
        market: $page.data.market,
        country: $page.data.userCountry,
        sessionId: $page.data.sessionId,
        player: $page.data.player,
        url: $page.url,
        bypassCache: $page.data.bypassCache,
        authBootstrap,
        fetch,
        noScroll
    });

    onGatekeeperInitiated();

    $: updateGatekeeperContext({
        market: $page.data.market,
        country: $page.data.userCountry,
        sessionId: $page.data.sessionId,
        player: $page.data.player,
        bypassCache: $page.data.bypassCache
    });
</script>

<svelte:body use:toggleClasses={{ 'overflow-hidden': $noScroll }} />
